export const OR_SEPARATOR = ' OR ';
export const SPACE = ' ';
export const PARTICIPANT_QUERY_FORMAT_STRING = 'participants:({0})';
export const PARTICIPANT_DISPLAYNAME_QUERY_FORMAT_STRING = 'participants:("{0}")';
